import { render, staticRenderFns } from "./customerChurn.vue?vue&type=template&id=47ca9f9b&scoped=true&"
import script from "./customerChurn.vue?vue&type=script&lang=js&"
export * from "./customerChurn.vue?vue&type=script&lang=js&"
import style0 from "./customerChurn.vue?vue&type=style&index=0&id=47ca9f9b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca9f9b",
  null
  
)

export default component.exports